import Vue from 'vue';
// import analysis from '@xy/analysis';
import router from '@/router';

const PROJECT_SPM = 'IPUNIQUE_CLIENT';

// analysis.init({
//   data: {
//     env: process.env.NODE_ENV === 'production' ? 'prod' : 'dev',
//     biz_source: 'BBMALL',
//   },
//   config: {
//     dsn: process.env.NODE_ENV === 'production' ? 'https://xyplus.xyb2b.com/xy.gif' : 'http://xyplus.xyb2b.com.cn/xy.gif',
//   },
//   debug: false,
// });

const getPage = (path = window.location.pathname) => {
  const route = routes.find((item, spm) => `/client${item.path}`.startsWith(path));
  return route
    ? {
        spm: String(route.spm),
        title: route.name,
      }
    : {
        spm: '0',
        title: '',
      };
};

Vue.directive('trackClick', {
  inserted: function(el, binding) {
    // const currentPage = getPage();
    // const data = binding.value;
    // const trackData = {
    //   ...data,
    //   spm: data.spm.includes('.') ? data.spm : `${PROJECT_SPM}.${currentPage.spm}.${data.spm}`,
    // };

    // el.addEventListener('click', () => {
    //   analysis.trackEvent.click(trackData);
    // });
  },
});

Vue.directive('trackExposure', {
  inserted: function(el, binding) {
    // const currentPage = getPage();
    // const data = binding.value;
    // const trackData = {
    //   ...data,
    //   spm: data.spm.includes('.') ? data.spm : `${PROJECT_SPM}.${currentPage.spm}.${data.spm}`,
    // };
    // const ob = new IntersectionObserver((entries) => {
    //   entries.forEach((entry) => {
    //     if (entry.isIntersecting) {
    //       analysis.trackEvent.exposure(trackData);
    //       ob.unobserve(el);
    //     }
    //   });
    // });
    // ob.observe(el);
  },
});

export const reportPv = (path) => {
  const currentPage = getPage(path);
  const trackData = {
    spm: `${PROJECT_SPM}.${currentPage.spm}`,
    params: { title: currentPage.title },
  };
  analysis.trackEvent.view(trackData);
};

const routes = [
  {
    path: '/work',
    name: '工作台',
    index: 1,
  },
  {
    path: '/serviceList',
    name: '工作台',
    index: 2,
  },
  {
    path: '/user',
    name: 'user',
    index: 3,
  },
  {
    path: '/receiveCoupon',
    name: '领劵中心',
    index: 4,
  },
  {
    path: '/coupon',
    name: '我的优惠券',
    index: 5,
  },
  {
    path: '/myInvite',
    name: '我邀请的用户',
    index: 6,
  },
  {
    path: '/securitySetting',
    name: '安全设置',
    index: 7,
  },
  {
    path: '/monitor',
    name: '跟卖监控管理',
    index: 8,
  },
  {
    path: '/shoppingCart',
    name: '购物车',
    index: 9,
  },
  {
    path: '/sureOrder',
    name: '确认订单',
    index: 10,
  },
  {
    path: '/oaPaid',
    name: '确认订单',
    index: 11,
  },
  {
    path: '/login',
    name: '登录',
    index: 12,
  },
  {
    path: '/en/login',
    name: '英文登录',
    index: 13,
  },
  {
    path: '/serviceDetail',
    name: '商品详情',
    index: 14,
  },
  {
    path: '/infoDetail',
    name: '商标详情',
    index: 15,
  },
  {
    path: '/fillEvidence',
    name: '使用证据',
    index: 16,
  },
  {
    path: '/adjustCate',
    name: 'AdjustCate',
    index: 17,
  },
  {
    path: '/useEvidence',
    name: 'UseEvidence',
    index: 18,
  },
  {
    path: '/myOrder',
    name: '我的订单',
    index: 19,
  },
  {
    path: '/invoiceList',
    name: '我的发票',
    index: 20,
  },
  {
    path: '/invoiceDetails',
    name: '我的发票详情',
    index: 21,
  },
  {
    path: '/myPatent',
    name: '我的专利',
    index: 22,
  },
  {
    path: '/myPatent/detail/',
    name: '专利详情',
    index: 23,
  },
  {
    path: '/myPatent/fillInfomation/',
    name: '填写资料',
    index: 24,
  },
  {
    path: '/myPatent/succeed/',
    name: '资料提交成功',
    index: 25,
  },
  {
    path: '/myBrand',
    name: '我的商标',
    index: 26,
  },
  {
    path: '/reviewOpinions',
    name: '审查意见',
    index: 27,
  },
  {
    path: '/reviewOpinions/Details',
    name: '审查意见详情',
    index: 28,
  },
  {
    path: '/reviewOpinions/choosePlan',
    name: '审查意见选择方案',
    index: 29,
  },
  {
    path: '/trademarkMonitor',
    name: '商标监控',
    index: 30,
  },
  {
    path: '/trademarkMonitor/Details',
    name: '商标监控详情',
    index: 31,
  },
  {
    path: '/activity/crazyThursday',
    name: '疯狂星期四',
    index: 32,
  },
  {
    path: '/activity/sevenYears',
    name: '七周年',
    index: 33,
  },
  {
    path: '/activity618',
    name: '618秒杀',
    index: 34,
  },
  {
    path: '/activity',
    name: '活动页面',
    index: 35,
  },
  {
    path: '/lottery',
    name: '抽奖活动',
    index: 36,
  },
  {
    path: '/trademarkName',
    name: '商标核名',
    index: 37,
  },
  {
    path: '/trademarkMonitoring',
    name: '我收藏的商标',
    index: 38,
  },
  {
    path: '/trademarkCollect',
    name: '我收藏的起名',
    index: 39,
  },
  {
    path: '/myCollection',
    name: '我的收藏',
    index: 40,
  },
  {
    path: '/integralMal',
    name: '积分商城',
    index: 41,
  },
  {
    path: '/address',
    name: '地址管理',
    index: 42,
  },
  {
    path: '/address/edit',
    name: '地址编辑',
    index: 43,
  },
  {
    path: '/paymentSucceeded',
    name: '支付成功',
    index: 44,
  },
  {
    path: '/submittedSucceeded',
    name: '提交成功',
    index: 45,
  },
  {
    path: '/payment',
    name: 'Payment',
    index: 46,
  },
  {
    path: '/paymentSuccess',
    name: 'PaymentSuccess',
    index: 47,
  },
  {
    path: '/paymentFail',
    name: 'PaymentFail',
    index: 48,
  },
  {
    path: '/trademarkNameReviewReport',
    name: 'TrademarkNameReviewReport',
    index: 49,
  },
  {
    path: '/monitoringReport',
    name: '监控报告',
    index: 50,
  },
  {
    path: '/monitoringDetails',
    name: '监控详情',
    index: 51,
  },
  {
    path: '/monitoringSubscription',
    name: 'monitoringSubscription',
    index: 52,
  },
  {
    path: '/monitorSubscriptionAdmin',
    name: 'monitorSubscriptionAdmin',
    index: 53,
  },
  {
    path: '/userAgreement',
    name: '用户协议',
    index: 54,
  },
  {
    path: '/privacyPolicy',
    name: '隐私政策',
    index: 55,
  },
];



// WEBPACK FOOTER //
// ./src/libs/analysis.js